import { NO_GROWTH_BOOK_TEST } from 'root-constants/common'

export const getCurrentOnboardingVariant = (
  growthBookVariantId: string,
): string => `ab_variant_${growthBookVariantId || NO_GROWTH_BOOK_TEST}`
